import { TRIGGER_INITIATE_REPAYMENT_API_CALL, TRIGGER_INITIATE_REPAYMENT_API_CALL_SUCCESS } from 'redux/actionTypes';

export function triggerInitiateRepaymentApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_INITIATE_REPAYMENT_API_CALL,
		data,
		stopLoader,
		callback,
	};
}

export function triggerInitiateRepaymentApiCallSuccess(data) {
	return {
		type: TRIGGER_INITIATE_REPAYMENT_API_CALL_SUCCESS,
		data,
	};
}
